import signupApiConfig from './signup_api_config';

const config = {
  stripe: {
    apiKey: 'pk_test_51IY42qKaj3wxayY5OjvguoZgoRZfuoie4e6JSmmfrKvSkX0P7hUdLU3BmLSjSS5TqFquCu2vvGf0Oj6AYXP53Jv000ZCTm58wb',
    apiUrl: signupApiConfig.paymentUrl,
    currency: 'USD',
  },
};

export default config;
